import { render } from "./FormAddTalibe.vue?vue&type=template&id=52a8946c"
import script from "./FormAddTalibe.vue?vue&type=script&lang=js"
export * from "./FormAddTalibe.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Desktop/thecustomer/st-daara/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__